import axios, { CancelToken } from "axios";
import { CANCEL } from "redux-saga";

import * as env from "./../config/env";

let token;

axios.defaults.baseURL = env.SERVER;
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers.common["Accept"] = "application/json";

const headersConfig = () => {
  if (token) {
    return {
      Authorization: token,
    };
  }
  return {};
};

export const get = (url) => {
  const source = CancelToken.source();
  const headers = headersConfig();
  const req = axios.get(url, {
    headers,
    cancelToken: source.token,
  });
  req[CANCEL] = () => source.cancel();
  return req;
};

export const getLogs = (url, filter, query) => {
  const source = CancelToken.source();
  const headers = headersConfig();
  const config = {
    headers,
    params: {
      filter: filter ? JSON.stringify(filter) : null,
      ...query,
    },
    cancelToken: source.token,
  };
  const req = axios.get(url, config);
  req[CANCEL] = () => source.cancel();
  return req
    .then((rs) => {
      return rs;
    })
    .catch((e) => {
      // throw new AppError(e, e.message)
      return e;
    });
};

export const getData = (url, data) => {
  const source = CancelToken.source();
  const headers = headersConfig();
  const config = {
    headers,
    params: {
      ...data,
    },
    cancelToken: source.token,
  };
  const req = axios.get(url, config);
  req[CANCEL] = () => source.cancel();
  return req
    .then((rs) => {
      return rs;
    })
    .catch((e) => {
      // throw new AppError(e, e.message)
      return e;
    });
};

export const getRequest = (url, params) => {
  const source = CancelToken.source();
  const headers = headersConfig();
  const config = {
    headers,
    params,
    cancelToken: source.token,
  };
  const req = axios.get(url, config);
  req[CANCEL] = () => source.cancel();
  return req;
};

export const getDataProfiling = (url, data) => {
  const source = CancelToken.source();
  const headers = headersConfig();
  const config = {
    params: {
      ...data,
    },
    cancelToken: source.token,
  };
  const req = axios.get(url, config);
  req[CANCEL] = () => source.cancel();
  return req
    .then((rs) => {
      return rs;
    })
    .catch((e) => {
      // throw new AppError(e, e.message)
      return e;
    });
};

// TODO xóa bỏ mấy hàm kiểu này trong project, nên throw error thay vì return error
export const post = (url, data) => {
  const source = CancelToken.source();
  const headers = headersConfig();
  const req = axios.post(url, data, {
    // ...postConfig,
    headers,
    cancelToken: source.token,
  });
  req[CANCEL] = () => source.cancel();
  return req
    .then((rs) => {
      return rs;
    })
    .catch((e) => {
      // throw new AppError(e, e.message)
      return e;
    });
};

// post throw error
export const postRequest = (url, data, config) => {
  const source = CancelToken.source();
  const headers = headersConfig();
  const req = axios.post(url, data, {
    headers,
    cancelToken: source.token,
    ...config,
  });
  req[CANCEL] = () => source.cancel();
  return req;
};

export const postRequestPreserve = (url, data) => {
  const headers = headersConfig();
  const baseURL = env.SERVER.endsWith("/")
    ? env.SERVER.slice(0, -1)
    : env.SERVER;
  return fetch(`${baseURL}${url}`, {
    method: "POST",
    body: JSON.stringify(data),
    keepalive: true,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...headers,
    },
  });
};

export const postUpload = (url, data) => {
  const source = CancelToken.source();
  const formData = new FormData();
  formData.append("file", data);
  const headers = {
    Authorization: token,
    "content-type": "multipart/form-data",
  };
  const req = axios.post(url, formData, {
    // ...postConfig,
    headers,
    cancelToken: source.token,
  });
  req[CANCEL] = () => source.cancel();
  return req
    .then((rs) => {
      return rs;
    })
    .catch((e) => {
      // throw new AppError(e, e.message)
      return e;
    });
};

export const put = (url, data) => {
  const source = CancelToken.source();
  const headers = headersConfig();
  const req = axios.put(url, data, {
    headers,
    cancelToken: source.token,
  });
  req[CANCEL] = () => {
    source.cancel();
  };
  return req
    .then((rs) => {
      return rs;
    })
    .catch((e) => {
      // throw new AppError(e, e.message)
      return e;
    });
};

export const putRequest = (url, data, config) => {
  const source = CancelToken.source();
  const headers = headersConfig();
  const req = axios.put(
    url,
    data,
    {
      headers,
      cancelToken: source.token,
    },
    config
  );
  req[CANCEL] = () => {
    source.cancel();
  };
  return req;
};

export const del = (url) => {
  const source = CancelToken.source();
  const headers = headersConfig();
  const req = axios.delete(url, {
    headers,
    cancelToken: source.token,
  });
  req[CANCEL] = () => source.cancel();
  return req;
};

export const patch = (url, data) => {
  const source = CancelToken.source();
  const headers = headersConfig();
  const req = axios.patch(url, data, {
    headers,
    cancelToken: source.token,
  });
  req[CANCEL] = () => {
    source.cancel();
  };
  return req
    .then((res) => {
      return res;
    })
    .catch((e) => {
      // throw new AppError(e, e.message)
      return e;
    });
};

export const setToken = (newToken) => {
  token = newToken;
};
